module.exports = __webpack_public_path__ + "img/square.48262161.png";